module.exports = __webpack_public_path__ + "img/npm.6f7aeee8.svg";